import React, { Component } from "react";
import styled from "styled-components";
import onWebviewClose from "./Button";

const WarningIcon = styled.div`
  position: absolute;
  width: 80px;
  height: 76px;
  left: 50%;
  top: 50%;
  margin-left: -40px;
  margin-top: -38px;
`;

const CloseBtn = styled.button`
  font-size: 1.5rem;
  background-color: transparent;
  border: 0;
  position: absolute;
  top: 0;
  right: 0;
  outline: 0;
  padding: 0px;
`;

const ErrorMsg = styled.div`
  position: absolute;
  top: 50%;
  width: 100%;
  text-align: center;
  margin-top: 43px;
`;

class Shield extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      info: null,
    };
  }

  componentDidCatch(error, info) {
    this.setState({
      error: error,
      info: info,
    });
  }

  render() {
    if (this.state.error) {
      return (
        <>
          <CloseBtn onClick={onWebviewClose}>
            <svg
              style={{ padding: "0.515rem 1.2985rem" }}
              width="26"
              height="26"
              viewBox="0 0 26 26"
            >
              <g fill="none" fillRule="evenodd">
                <g fillRule="nonzero">
                  <g>
                    <path
                      d="M0 0H28V28H0z"
                      transform="translate(-596 -8) translate(596 8)"
                    />
                    <path
                      fill="#FAFAFA"
                      d="M21.467 6.535c.466.467.466 1.05.116 1.517l-.116.117-5.717 5.833 5.833 5.717c.467.466.467 1.166 0 1.633-.466.467-1.05.467-1.516.117l-.234-.117L14 15.635 8.167 21.47c-.467.466-1.167.466-1.634 0-.466-.467-.466-1.05-.116-1.517l.116-.117 5.834-5.833-5.834-5.717c-.466-.466-.466-1.166 0-1.633.467-.467 1.05-.467 1.517-.117l.117.117L14 12.37l5.717-5.717c.583-.583 1.283-.583 1.75-.117z"
                      transform="translate(-596 -8) translate(596 8)"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </CloseBtn>
          <WarningIcon>
            <img src="/error.png" alt="error png" />
          </WarningIcon>
          <ErrorMsg>
            {/* {this.state.error.message} */}
            Could not get information
          </ErrorMsg>
        </>
      );
    }

    return this.props.children;
  }
}

export default Shield;
